import dayjs from "dayjs";

export const REPORT_LIST_SORT = "-created_at";

export const REPORT_ORDERS_SIDEBAR_KEYS = [
	"type",
	"status",
	"orderNumber",
	"client",
	"courier",
	"author",
	"dishes",
	"paymentTypes",
	"with_removed_goods"
];

export const REPORT_DISHES_SIDEBAR_KEYS = ["orderNumber", "author", "dish"];

const isActiveFilterValue = (key, value) => {
	if (value == null || value === "") return false;
	if (key === "with_removed_goods") return Number(value) === 1;
	return true;
};

export const hasReportSidebarFilters = (params, sidebarKeys) => {
	return sidebarKeys.some(key => isActiveFilterValue(key, params[key]));
};

export const getReportExtraDateRange = ({ start_at, end_at, params, sidebarKeys }) => {
	if (start_at && end_at) {
		return { start_at, end_at };
	}

	if (hasReportSidebarFilters(params, sidebarKeys)) {
		return {};
	}

	return {
		start_at: dayjs().startOf("month").unix(),
		end_at: dayjs().endOf("month").unix()
	};
};
